import { createEntityAdapter } from '@reduxjs/toolkit';

import type { ShippingMethod } from './shipping_methods.types';

const shippingMethodsAdapter = createEntityAdapter<ShippingMethod>({
  selectId(sm) {
    return sm.api_id;
  },
});

export default shippingMethodsAdapter;
